'use strict';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
Entry.PopupList = /*#__PURE__*/function () {
  function PopupList(dom) {
    (0, _classCallCheck2["default"])(this, PopupList);
    this.view = dom;
  }
  return (0, _createClass2["default"])(PopupList, [{
    key: "getView",
    value: function getView() {
      return this.view;
    }
  }, {
    key: "resize",
    value: function resize() {}
  }]);
}();